var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActivityDashboard = function SvgActivityDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.107 8.143H.68A.679.679 0 0 0 0 8.82v8.143C0 18.09.911 19 2.036 19h4.071a.679.679 0 0 0 .679-.679v-9.5a.679.679 0 0 0-.679-.678Zm-.678 9.5H2.036a.679.679 0 0 1-.679-.679V9.5H5.43v8.143ZM16.964 0H2.036A2.036 2.036 0 0 0 0 2.036v4.071c0 .375.304.679.679.679H18.32A.679.679 0 0 0 19 6.107V2.036A2.036 2.036 0 0 0 16.964 0Zm.679 5.429H1.357V2.036c0-.375.304-.679.679-.679h14.928c.375 0 .679.304.679.679v3.393Zm.678 2.714h-9.5a.679.679 0 0 0-.678.678v9.5c0 .375.304.679.678.679h8.143A2.036 2.036 0 0 0 19 16.964V8.821a.679.679 0 0 0-.679-.678Zm-.678 8.821a.679.679 0 0 1-.679.679H9.5V9.5h8.143v7.464Z",
    fill: "#264D6D",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivityDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activity-dashboard.b37176e7.svg";
export { ForwardRef as ReactComponent };